import { Routes } from '@angular/router';
import { RoutesMapper } from './routes-mapper';
import { SsoLoginComponent } from './components/sso-login/sso-login.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: RoutesMapper.LOGIN,
    component: SsoLoginComponent,
  },
  {
    path: RoutesMapper.DASHBOARD,
    loadComponent: () =>
      import('./components/dashboard/dashboard').then((m) => m.Dashboard),
    canActivate: [authGuard],
  },
  {
    path: '**',
    redirectTo: RoutesMapper.LOGIN,
  },
];
